module.exports = __webpack_public_path__ + "components/star-rating/static/white/8-bbb7fca7a0c4b91b089095fa3289c4c9.svg";